import React from 'react';

const withLayout = (Layout, props) => (Content) => () => <Layout {...props}><Content /></Layout>;

export default withLayout;
